module.exports = __webpack_public_path__ + "static/media/17.2fd0c618.JPG";